import {
  CSP_NONCE,
  DOCUMENT,
  EnvironmentInjector,
  inject,
  Injectable,
  Renderer2,
  RendererFactory2,
  runInInjectionContext,
} from '@angular/core';
import { ContentService } from '../content/content.service';

export const StoreIds = {
  GASTROLUX: 165,
};

const salesiqInitScriptSrc = 'https://salesiq.zohopublic.eu/widget?wc=siq376ddf7844bdce27ea78f28188e30214fde447b721c4f26514f30b9c73e9910e';
const salesiqInitScriptId = 'zsiqscript';

const SALESIQ_SCRIPT_FORMAT = `window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}`;

@Injectable()
export class SalesIQService {
  private doc = inject<Document>(DOCUMENT);
  private rendererFactory = inject(RendererFactory2);
  private nonce = inject(CSP_NONCE);
  private renderer: Renderer2;

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);

    this.setSalesIQ();
  }

  setSalesIQ() {
    this.installSalesIQ();
  }

  private installSalesIQ() {
    const head = this.doc.getElementsByTagName('head')[0];

    const ctScriptElement = this.renderer.createElement('script') as HTMLScriptElement;
    ctScriptElement.nonce = this.nonce;
    ctScriptElement.innerHTML = SALESIQ_SCRIPT_FORMAT;
    head.appendChild(ctScriptElement);

    const salesiqInitElement = this.renderer.createElement('script') as HTMLScriptElement;
    salesiqInitElement.nonce = this.nonce;
    salesiqInitElement.src = salesiqInitScriptSrc;
    salesiqInitElement.id = salesiqInitScriptId;
    salesiqInitElement.defer = true;
    head.appendChild(salesiqInitElement);
  }
}

export const salesIQServiceFactory = (contentService: ContentService, envInjector: EnvironmentInjector) => {
  const merchantId = contentService.getMerchantId();
  if (Object.values(StoreIds).includes(merchantId)) {
    return runInInjectionContext(envInjector, () => new SalesIQService());
  }

  return null;
};
